import(/* webpackMode: "eager" */ "/vercel/path0/src/app/schedule/page.tsx");
